/** @format */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMoreBrokerObjects,
  fetchMoreBrokerObjectsBySlug
} from 'stateContainer/actions';
import { Button } from 'react-bootstrap';
import { LoaderButton } from 'components/ButtonSyncLoader';

export default function FetchMore(props) {
  const dispatch = useDispatch();
  const showMoreText = props.t(`lang_common:broker_profile.showmore.text`);
  // eslint-disable-next-line no-unused-vars
  const {
    // eslint-disable-next-line no-unused-vars
    totalPages,
    page,
    profileId,
    profileSlug,
    filteringData
  } = props;

  const {
    brokerObjects: { isFetchingMore }
  } = useSelector((state) => state);

  const statusPayload = {};

  if (filteringData.statuses.length > 0) {
    statusPayload.statuses = filteringData.statuses.join(',');
  }

  return (
    <div className='broker-profile-show-more-container'>
      {/* {totalPages !== page && ( */}

      {!isFetchingMore && (
        <Button
          className='btn btn-white'
          onClick={() => {
            if (profileId) {
              dispatch(
                fetchMoreBrokerObjects({
                  ...statusPayload,
                  brokerId: profileId,
                  page: page + 1
                })
              );
            } else if (profileSlug) {
              dispatch(
                fetchMoreBrokerObjectsBySlug({
                  ...statusPayload,
                  brokerSlug: profileSlug,
                  page: page + 1
                })
              );
            }
          }}>
          {showMoreText}
        </Button>
      )}

      {/* )} */}
      <LoaderButton
        display={isFetchingMore}
        text={props.t('lang_common:broker_profile:showmore:loader:text')}
      />
    </div>
  );
}
